import React from "react";

import { connect } from "../i18n/connect";
import { actions } from "../redux/modules/bottomNavigation";
import { getDesktopNotificationsOpen } from "../redux/modules/bottomNavigation/selector";
import {
  setFilters,
  setSelectedTab
} from "../redux/modules/newNotifications";

const mapStateToProps = state => ({
  notificationsOpen: getDesktopNotificationsOpen(state)
});

const mapDispatchToProps = dispatch => ({
  setNotificationsOpen: ({ open, tabName }) => {
    if (tabName) {
      dispatch(setSelectedTab(tabName));
    }

    dispatch(actions.setDesktopNotificationsOpenAction(open));
  },
  openNotificationsPanel: (isDesktop, tabName, filters) => {
    if (tabName) {
      dispatch(setSelectedTab(tabName));
    }

    if (filters) {
      dispatch(setFilters(filters));
    }

    if (isDesktop) {
      dispatch(actions.setDesktopNotificationsOpenAction(true));
      return;
    }

    dispatch(actions.setValueAction("notifications"));
  }
});

export default function withDesktopNotificationsPanel(WrappedComponent) {
  @connect(mapStateToProps, mapDispatchToProps)
  class WithDesktopNotificationsPanel extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithDesktopNotificationsPanel;
}
